






































































import 'reflect-metadata'
import { Vue, Component } from 'vue-property-decorator'
import AssetRow from '@/components/Assets/AssetRow.vue'
import AssetsDataTable from '@/components/Assets/AssetsDataTable.vue'
import Tooltip from '@/components/rows/Tooltip.vue'
import TooltipHeading from '@/components/misc/TooltipHeading.vue'
import { Asset } from '@/js/Asset'
import { AVAX_ID } from '@/known_assets'

@Component({
    components: {
        Tooltip,
        TooltipHeading,
        AssetRow,
        AssetsDataTable,
    },
})
export default class AssetsPage extends Vue {
    get assetsLoaded(): boolean {
        return this.$store.state.assetsLoaded
    }

    get assets(): Asset[] {
        let res: Asset[] = this.$store.getters.assetsArrayNonProfane
        const avax: Asset = res.find(
            (asset: Asset) => asset.id === AVAX_ID
        ) as Asset
        res = res.filter((asset: Asset) => asset.id !== AVAX_ID)
        res.sort((a: Asset, b: Asset) => b.txCount_day - a.txCount_day)
        res.unshift(avax)
        return res
    }

    get assetNames(): any[] {
        return this.assets.map((asset: Asset) => {
            return {
                name: asset.name,
                value: 1,
            }
        })
    }
}
